import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { InvDailyFormComponent } from "../inv-daily-form/inv-daily-form.component";
import { SimpleModalComponent } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.component";
import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { take } from "rxjs/operators";
import { Branch } from "projects/sepidz-web-framework/src/lib/models";
import { GridFilter, LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";
import { InvDailyHeaderSetting } from "../../model/inv-daily-header.model";
import { Subject } from "rxjs";
import { InvDailyHeaderMenuComponent } from "../inv-daily-header-menu.component";
import { ContextMenuEnum } from "src/app/frontoffice/order/model/contextMenuenum";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormSettingModel } from "projects/sepidz-web-framework/src/lib/models/formsettingmodel";

@Component({
  selector: "ngx-inv-daily-list",
  templateUrl: "./inv-daily-list.component.html",
  styleUrls: ["./inv-daily-list.component.scss"],
})
export class InvDailyListComponent extends BaseListComponent {
  isAdd: boolean = true;
  isEdit: boolean = true;
  isDelete: boolean = true;
  noToolBar = false;
  hideToolbar = false;
  IgnoreDelete: boolean = false;
  deleteMessage: string = "";
  formVisible: boolean;
  hasPermission: boolean = false;
  InvDailyHeaderSetting: InvDailyHeaderSetting;
  unSortableFilterable: string[] = [];
  public contextmenuEnum: typeof ContextMenuEnum = ContextMenuEnum;
  menu = InvDailyHeaderMenuComponent;
  settingChanges$ = new Subject();
  closerCallback: (component: SimpleModalComponent<any, any>) => Promise<any>;

  formGroup = new UntypedFormGroup({
    branchFilter: new UntypedFormControl(),
  });

  allBranchesExceptCallCenter: Branch[] = [];

  onFilter: GridFilter[] = [
    {
      Filed: "Code",
      Value: 0,
      Skip: 0,
      Take: 15,
      Operator: "desc",
      Type: "S",
    },
  ];

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, public storage: LocalStoreManager) {
    super();
    this.inputEditorform = InvDailyFormComponent;
    this.formVisible = !this.isMultiBranch;
  }

  ngOnInit() {
    this.apiName = "InvDailyHeader";
    this.areaName = "RestaurantSale";
    this.reportName = "InvDailyHeader";
    this.label = this.translate("ClientApp.Pages.PageMenu.InvDailyHeader");
    this.httpCommonService
      .getList("Branch/GetAllBranch")
      .pipe(take(1))
      .subscribe(async (data: Branch[]) => {
        this.allBranchesExceptCallCenter = data.filter((x) => !x.AccessToAllBranches);
      });
    if (this.isMultiBranch) {
      this.onBranchFilterClear();
    }
    this.getSetting();
    this.settingChanges$.pipe(take(1)).subscribe((x) => {
      this.getSetting();
    });
    const columnsToExclude = ["KindString"];

    this.unSortableFilterable.push(...columnsToExclude);
  }

  public onBranchFilterChanged(branches: Branch[]): void {
    if (branches.length) this.filterBranchWithOrOperator(branches);
    else this.onBranchFilterClear();
  }

  public onBranchFilterClear(): void {
    this.onFilter = [
      {
        Filed: "BranchId",
        Value: 0,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      },
    ];
  }

  getSetting() {
    this.httpCommonService
      .getList("InvDailyHeaderFormSetting/GetSetting")
      .pipe(take(1))
      .subscribe((res: FormSettingModel) => {
        this.InvDailyHeaderSetting = res;
      });
  }

  private filterBranchWithOrOperator(branches: Branch[]): void {
    this.onFilter = Object.assign([], []);
    branches.forEach((branch) => {
      const branchFilter: GridFilter = {
        Filed: "BranchId",
        Value: branch.Id,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      };

      if (branches.length > 1) {
        branchFilter.Logic = "or";
      }
      this.onFilter.push(...[branchFilter]);
    });
  }
}
